/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Repo-wide wrapper for autorun. */
import { type IReactionDisposer, autorun as mobxAutorun } from "mobx";

export function autorun(name: string, func: () => void): IReactionDisposer {
    return mobxAutorun(func, { name: `autorun(${name})` });
}
